<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useProfileStore } from '~/stores/profileState'

const { t } = useI18n()
const router = useRouter()
const profileStore = useProfileStore()

const props = defineProps({
  showBackButton: {
    type: Boolean,
    default: true
  }
})

// Computed property pro zobrazení tlačítka zpět
const shouldShowBackButton = computed(() => {
  // Skryjeme tlačítko zpět, pokud je profil nekompletní
  return props.showBackButton && !profileStore.isProfileIncomplete
})
</script>

<template>
  <div class="flex min-h-screen flex-col">
    <AppNavbar />

    <main class="grow">
      <div class="flex w-full flex-wrap items-start justify-between">
        <div v-if="shouldShowBackButton" class="sofax editor-ui my-3 hidden w-full px-4 md:block">
          <div class="mx-auto max-w-screen-xl">
            <LocaleLink
              class="inline-flex cursor-pointer items-center gap-2 !text-sm font-semibold !text-ink hover:!text-accent dark:!text-white dark:hover:!text-lilac"
              @click="router.back()"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="size-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              {{ t('common.backButton') }}
            </LocaleLink>
          </div>
        </div>
        <slot />
      </div>
    </main>

    <!-- Footer pouze na desktop zařízeních -->
    <div class="hidden md:block">
      <AppFooter />
    </div>

  </div>
</template>
